import axios from 'axios';
import { ITime } from './contexts/ConfigContext/ConfigContext';
const API_URL = 'http://137.74.92.81:3099/';

export interface IUser {
  id: number;
  name: string;
  windowsId: string;
  country: string;
  lastGames: ITime[];
  best1: ITime[];
  best2: ITime[];
  best3: ITime[];
}

export interface IBestTime extends ITime {
  name: string;
  country: string;
  additional?: string[];
}

export interface IBest {
  best1: IBestTime[],
  best2: IBestTime[],
  best3: IBestTime[],
}

export async function getUserInfo(userWindowsId: string): Promise<IUser> {
  const data = await axios.post(API_URL + 'getUser', { windowsId: userWindowsId });
  return data.data as IUser;
}

export async function saveGameTime(userId: number, level: number, time: number, clicks: number): Promise<boolean> {
  const data = await axios.post(API_URL + 'saveGameTime', { userId, level, time, clicks });
  return data.data as boolean;
}

export async function changeUserName(userId: number, newUserName: string): Promise<{success: boolean, exists?: boolean}> {
  const data = await axios.post(API_URL + 'changeUserName', { userId, newUserName });
  return data.data as {success: boolean, exists?: boolean};
}

export async function getBestTimes(filter: string): Promise<IBest> {
  const data = await axios.post(API_URL + 'getBestTimes', { filter });
  return data.data as IBest;
}